/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateLocalizationPreference
 */
export interface UpdateLocalizationPreference {
    /**
     * 
     * @type {string}
     * @memberof UpdateLocalizationPreference
     */
    countryCode: string;
}

/**
 * Check if a given object implements the UpdateLocalizationPreference interface.
 */
export function instanceOfUpdateLocalizationPreference(value: object): value is UpdateLocalizationPreference {
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    return true;
}

export function UpdateLocalizationPreferenceFromJSON(json: any): UpdateLocalizationPreference {
    return UpdateLocalizationPreferenceFromJSONTyped(json, false);
}

export function UpdateLocalizationPreferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLocalizationPreference {
    if (json == null) {
        return json;
    }
    return {
        
        'countryCode': json['countryCode'],
    };
}

export function UpdateLocalizationPreferenceToJSON(value?: UpdateLocalizationPreference | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'countryCode': value['countryCode'],
    };
}

